export default class CAGlobalUsersModel {
    [key: string]: any;
    group_date?: Date;
    store_id!: number;
    store_name!: string;
    constructor(init: Partial<CAGlobalUsersModel> & Required<{store_id: number, store_name: string}>) {
        Object.assign(this, init);
        if (init.group_date) this.group_date = new Date(init.group_date);
    }
}